import { memo } from 'react';

const DeleteSquareIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="13"
			height="13"
			fill="none"
			viewBox="0 0 13 13"
			{...props}
		>
			<g clipPath="url(#clip0_44_39208)">
				<circle cx="6.273" cy="6.984" r="6" fill="#A6A6A6"></circle>
				<path
					stroke="#fff"
					strokeLinecap="square"
					strokeLinejoin="round"
					strokeWidth="0.7"
					d="M8.656 4.602 3.891 9.367M3.89 4.602l4.766 4.765"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_44_39208">
					<path fill="#fff" d="M.273.984h12v12h-12z"></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default memo(DeleteSquareIcon);
